export default {
  title: 'Доплата',
  description: 'Доплата — это определённая сумма в долларах, которую вы обязаны заплатить за покрываемые медицинские услуги или рецепты в соответствии с вашим страховым планом.',
  'is-paid': 'оплачена',
}
